module.exports = __webpack_public_path__ + "static/assets/0f04cfc1761e93eeb8cdcb5b406110ea.gif";